import { isArray } from 'util';
import { ManufacturingOrderWithTask } from '../manufacturing-order-with-task';

export class ManufacturingOrderWithTaskBuilder {
  static fromJson(json) {
    return (json)
      ? new ManufacturingOrderWithTask(
        json.hash,
        json.code,
        json.projectNumber,
        json.elementCode,
        json.taskDescription,
        json.elementNumber
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ManufacturingOrderWithTaskBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-with-task.builder.ts